import {Component, OnInit} from '@angular/core';
import {CustomerDataSyncService} from '../../@shared/new-services/customer-data-sync.service';
import {MessageService} from 'primeng/api';
import {UserMgmtService} from "../../@shared/new-services/user-mgmt.service";

@Component({
    selector: 'app-customer-onboarding',
    templateUrl: './customer-onboarding.component.html',
    styleUrls: ['./customer-onboarding.component.scss']
})
export class CustomerOnboardingComponent implements OnInit {

    businessEntity: any;
    importBookings = true;
    importInvoices = true;
    importSOA = true;
    selectedBusinessEntity: any;
    bookingsSucceed: any = {};
    invoicesSucceed: any = {};
    soaSucceed: any = {};
    isBookingsImporting: boolean;
    isInvoicesImporting: boolean;
    isSoaImporting: boolean;
    visibleLocationDialog = false;
    locationGid = '';
    locationName: string;
    corporationGid: string;
    isAddingLocation = false;

    constructor(private customerDataSyncService: CustomerDataSyncService, private messageService: MessageService,
                private userMgmtService: UserMgmtService) {
    }

    ngOnInit(): void {
        this.getBusinessEntity();
    }

    getBusinessEntity() {
        this.userMgmtService.getBusinessEntitiesForCustomerOnBoard()
            .subscribe(
                (x) => {
                    this.businessEntity = x;
                }, (error) => {
                    this.messageService.add({});
                }
            );
    }

    importData(module: string) {
        if (!this.selectedBusinessEntity) {
            this.messageService.add({
                summary: 'Sync Error !',
                severity: 'info',
                detail: 'Please Select Customer',
                key: 'sync-error',
            });
            return;
        }
        if (module === 'bookings') {
            // this.isBookingsImporting = true;
            this.bookingsSucceed.succeed = true;
            this.bookingsSucceed.message = 'Bookings will be imported ! Please check after sometime';
            this.customerDataSyncService
                .syncBookingsData(this.selectedBusinessEntity)
                .subscribe((x) => {

                }, (error) => {
                });
        }
        if (module === 'invoices') {
            // this.isInvoicesImporting = true;
            this.invoicesSucceed.succeed = true;
            this.invoicesSucceed.message = 'Invoices will be imported ! Please check after sometime';
            this.customerDataSyncService
                .syncInvoicesData(this.selectedBusinessEntity)
                .subscribe((x) => {
                }, (error) => {
                });
        }
        if (module === 'soa') {
            this.soaSucceed.succeed = true;
            this.soaSucceed.message = 'SOA will be imported ! Please check after sometime';
            this.customerDataSyncService
                .syncSOAData(this.selectedBusinessEntity)
                .subscribe((x) => {

                }, (error) => {

                });
        }
    }

    onAddOfCustomer() {
        this.locationName = null;
        this.corporationGid = null;
        this.isAddingLocation = true;
        const locationGid = this.locationGid;
        this.customerDataSyncService
            .createNewBusinessEntity(locationGid)
            .subscribe(
                (x) => {
                    this.isAddingLocation = false;
                    this.locationName = x?.name;
                    this.corporationGid = x?.corporationGid;
                    this.messageService.add({
                        summary: 'Customer !',
                        severity: 'success',
                        detail: 'Customer Added Successfully',
                        key: 'sync-error',
                    });
                    setTimeout(() => {
                        this.visibleLocationDialog = false;
                    }, 1500);
                    // tslint:disable-next-line:no-shadowed-variable
                }, (error) => {
                    this.isAddingLocation = false;
                    this.messageService.add({
                        summary: 'Adding Customer Error !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'sync-error',
                    });
                }
            );
    }
}
